import { observer } from 'mobx-react-lite'
import { useTranslation } from 'react-i18next'

import { getOrderItemPageKey, getOrderPageKey } from 'sections/LKSection/modules/OrderModule/utils'

import { OrderItemStatusHeader } from '../OrderItemStatusHeader/OrderItemStatusHeader'

export const OrderStatusDeclined = observer(() => {
  const { t } = useTranslation()

  return (
    <>
      <OrderItemStatusHeader
        type="failure"
        title={t(getOrderItemPageKey('step'), { count: 2 })}
        subTitle={t(getOrderPageKey('Отклонена'))}
        isActive
      />
    </>
  )
})
